"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalcPricePercentageFormat = CalcPricePercentageFormat;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _currencyHelper = require("@eig-builder/core-utils/helpers/currency-helper");

function CalcPricePercentageFormat(params) {
  var currencyObj = {
    code: params.colDef.currencySymbol
  };
  var price = params.value;

  if (!(0, _isNil["default"])(params.value)) {
    if (!(0, _isNil["default"])(params.data.discount)) {
      price = params.value - params.value * (params.data.discount / 100);
    }
  }

  return (0, _currencyHelper.formatCurrency)(price, currencyObj);
}